/**
 * railDataContainer.tsx
 */
import ScreenUtils from '@screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';
import { RailDisplayMode } from '@shared/types/enums/rail';

/**
 * Get the style for the RailDataContainer component.
 */
const getStyle = (displayMode?: RailDisplayMode) => {
  switch (displayMode) {
    case RailDisplayMode.EPG:
      return {
        width: `${1720 * ScreenUtils.widthRatio}px`,
      };
    default:
      return {
        width: 'max-content',
      };
  }
};

const RailDataContainer = withOpacity(styled.div<{
  displayMode?: RailDisplayMode;
}>`
  ${(props) => {
    const { width } = getStyle(props.displayMode);
    return `
      display: flex;
      width: ${width};
      div:last-child {
        margin-right: 0;
      }
    `;
  }}
`);

export default RailDataContainer;
